import React from "react";
import { Layout } from "antd";
import { AuthHeader } from "../components";
const { Content } = Layout;

const AuthLayout = ({ children }) => (
  <Layout>
    <AuthHeader />
    <div className="px-0 lg:px-12 py-0 lg:py-10 flex justify-between">
      <Content className="w-full px-0 xl:px-10 overflow-hidden auth-content">
        {children}
      </Content>
    </div>
  </Layout>
);

export default AuthLayout;
